var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('reseller-invoice-form',{attrs:{"loading":_vm.loading,"resellerInvoiceData":_vm.resellerInvoice,"formErrors":_vm.formErrors},on:{"resellerInvoiceSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }